<template>
  <div class="cm-dashboard" v-loading="loading"
    :style="{ background: properties.bgColor, border: properties.border, borderRadius: properties.borderRadius, height: (contenitoreHeight) + 'px' }">
    <div class="tab">
      <div v-if="properties.icona === ''" class="tipologia">
        <span>{{ properties.title.toUpperCase() }}</span>
      </div>
      <div v-else class="tipologia-icon">
        <icon :name="properties.icona" scale="2.9" :style="{ color: properties.iconColor }"></icon>
        <div class="titolo">
          <span class="riga1 truncate">{{ properties.title.toUpperCase() }}</span>
          <span class="riga2"></span>
        </div>
      </div>
      <el-carousel arrow="never" :autoplay="false" indicator-position="outside" @change="changeScheda"
        v-if="(cards.length > 0)" :style="{ height: (43 * this.properties.numSchede) + 'px' }">
        <el-carousel-item v-for="carouselTab in numCarouselTab" :key="carouselTab">
          <div class="card-cm" v-for="(item, index) in cards" :key="index">
            <div class="scheda pointer" :class="{ important: isImportant(item) }"
              v-if="item.container !== '' && item.container !== undefined" @click="downloadPDF(item)">
              <div class="scheda-cont truncate">
                {{ $t('docs.documentType.' + item.container + '.label') }}
              </div>
              <div class="scheda-data">
                {{ getDate(item) }}
              </div>
            </div>
            <div class="scheda" v-else></div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>

</template>

<script>
import mixinDownload from "../../assets/mixins/downloadDoc.js";
import moment from 'moment'

export default {
  name: 'ContentManager',
  mixins: [mixinDownload],
  props: {
    properties: {
      type: Object,
      required: true,
      default: function () {
        return {
          compressa: true,
          bgColor: '',
          border: '',
          borderRadius: '',
          icona: 'riv-tick',
          iconColor: '',
          title: '',
          url: '',
          numSchede: 6,
          numCarouselTab: 0,
        }
      }
    },
    contenitoreHeight: {
      type: Number
    }
  },
  i18n: {},
  data() {
    return {
      docs: [],
      cards: [],
      loading: false
    }
  },
  computed: {
    ifArrow: function () {
      if (this.numCarouselTab > 1) {
        return 'always'
      } else {
        return 'never'
      }
    }
  },
  mounted: function () {
    this.loadDocs()
  },
  methods: {
    loadDocs: function () {
      this.$set(this, 'docs', [])
      this.$set(this, 'loading', true)
      this.$set(this, 'numCarouselTab', 0)

      let today = moment()
      let dataAl = today.format('YYYYMMDD')
      let dataDal = today.subtract(1, 'months').format('YYYYMMDD')

      var obj = {
        params: {
          codLang: sessionStorage.getItem('codLang'),
          container: 'ultMese',
          dataDal: dataDal,
          dataAl: dataAl,
          pag_from: 1,
          pag_for: 99
        }
      }

      this.$http.get('documenti/' + this.$store.state.country + '/lstdocdip', obj).then(response => {
        if (response.body.rc === 0) {
          this.$set(this, 'docs', response.body.data)
          this.numCarouselTab = (this.docs.length % this.properties.numSchede > 0) ? (parseInt(this.docs.length / this.properties.numSchede) + 1) : (parseInt(this.docs.length / this.properties.numSchede))
          let i = 0
          while (i < this.properties.numSchede) {
            if (this.docs[i] !== undefined) {
              this.cards.push(this.docs[i])
            }
            i++
          }
          while (this.cards.length < this.properties.numSchede) {
            this.cards.push(obj)
          }
          this.$set(this, 'loading', false)
        } else {
          this.$set(this, 'loading', false)
        }
      }).catch(error => {
        this.$set(this, 'loading', false)
      })
    },
    changeScheda: function (newIndex, oldIndex) {
      this.$set(this, 'cards', [])
      for (let i = (newIndex * this.properties.numSchede); i <= (newIndex * this.properties.numSchede + (this.properties.numSchede - 1)); i++) {
        let obj = this.docs[i]
        if (obj !== null && obj !== undefined) {
          this.cards.push(this.docs[i])
        }
      }

      let obj = {
        anno: '',
        mese: '',
        container: '',
        keydoc: '',
        version: ''
      }

      while (this.cards.length < this.properties.numSchede) {
        this.cards.push(obj)
      }
    },
    sortDocs: function (array) {
      return array.sort(function (a, b) {
        var x = a.anno + a.mese
        var y = b.anno + b.mese
        return ((x > y) ? -1 : ((x < y) ? 1 : 0))
      })
    },
    getTitolo: function (doc) {
      if (doc.container === undefined) {
        return doc.oggetto
      } else if (doc.container == 'PAFPAGLETGEN') {
        return doc.tdo
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return doc.tit
      } else {
        return ''
      }
    },
    getDate: function (doc) {
      if (doc.container === undefined) {
        return ''
      } else if (doc.container == 'PAFPAGLETGEN') {
        return this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return doc.datada
      } else if (doc.container == 'PAIPAGMODCUD') {
        return doc.anno
      } else if (doc.mese && doc.anno) {
        return this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      } else {
        return ''
      }
    },
    getNome: function (doc) {
      if (doc.container === undefined) {
        return doc.oggetto
      } else if (doc.container == 'PAFPAGLETGEN') {
        let nome = this.$i18n.t('docs.documentType.' + doc.container + '.label') + + ' ' + doc.tdo
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return '[' + doc.datada + ']' + ' ' + doc.tit
      } else {
        let nome = this.$i18n.t('docs.documentType.' + doc.container + '.label')
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      }
    },
    getDocURL: function (doc) {
      console.log("ContentManager.vue - getDocURL: " + process.env.APP_ENV)
      if (['dev', 'qa'].includes(process.env.APP_ENV)) {
        let win = window.open('', '_blank')
        win.location.href = 'https://secureq.rivagroup.com/DocumentiTest/RivaAcciaio_Letterhead.pdf'
        win.focus()
        return
      }
      let keydoc = encodeURIComponent(doc.keydoc)
      let url = ('download/cm/' + this.getNomeUrl(doc) + '?keyDoc=' + keydoc + '&container=' + doc.container + '&token=' + sessionStorage.getItem('token'))
      let win = window.open(process.env.baseUrlSpring + url, '_blank')
      win.focus()
    },
    getNomeUrl: function (doc) {
      if (doc.container == 'PAFPAGLETGEN') {
        let nome = this.$i18n.t('documentType.' + doc.container + '.label', { titolo: '' })
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return '[' + doc.datada + ']' + ' ' + doc.tit
      } else {
        let nome = this.$i18n.t('documentType.' + doc.container + '.label')
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      }
    },
    isImportant: function (messaggio) {
      if (messaggio.seRead === 'Y') {
        return false
      } else {
        return true
      }
    },
    downloadPDF: function (doc) {
      console.log("ContentManager.vue - downloadPDF: " + process.env.APP_ENV)
      if (['dev', 'qa'].includes(process.env.APP_ENV)) {
        let win = window.open('', '_blank')
        win.location.href = 'https://secureq.rivagroup.com/DocumentiTest/RivaAcciaio_Letterhead.pdf'
        win.focus()
        return
      }
      let keydoc = encodeURIComponent(doc.keydoc)
      let nome = ''
      // if (!this.browserVersion()) {
      //  nome = this.getNome(doc)
      // }
      let win = window.open('', '_blank')
      this.$http.get('portale/' + this.$store.state.country + '/getTokenDoc').then(response => {
        if (response.body.wsToken) {
          let url = ('download/cm?keyDoc=' + keydoc + '&container=' + doc.container + '&nameDoc=' + nome +
            '&token=' + response.body.wsToken)
          // let win = window.open(process.env.baseUrl + url, '_blank')
          win.location.href = process.env.baseUrlSpring + url
          win.focus()
          // Richiamo il servizio di lettura
          console.log(doc.seRead)
          if (doc.seRead === 'N') {
            let obj = {
              'keyCM': doc.keydoc,
              'cliCM': doc.cliCM,
              'appCM': doc.appCM
            }
            this.$http.post('documenti/' + this.$store.state.country + '/savereaddoc', obj, {
              params: {
                codLang: sessionStorage.getItem('codLang')
              }
            })
              .then(response => {
                if (response.body.rc === 0) {
                  this.loadDocs()
                } else {
                  this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'error',
                    duration: process.env.duration
                  })
                }
              })
          }
        } else {
          this.$message({
            showClose: true,
            message: 'Error creating token',
            type: 'error',
            duration: process.env.duration
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.cm-dashboard {
  overflow: auto;
  padding-left: 10px;
  padding-right: 10px;

  .tipologia {
    .set-font(@color: @greenRiva, @size: 14px, @family: 'os-semibold');
    text-align: left;
    line-height: 30px;
    height: 30px;
    letter-spacing: 2px;
  }

  .tipologia-icon {
    height: 60px;

    //margin-bottom: 20px;
    .fa-icon {
      float: left;
      margin-top: 5px;
      width: 20%;
    }

    .titolo {
      height: 60px;
      float: right;
      width: 80%;

      .riga1 {
        width: 100%;
        .set-font(@color: @greenRiva, @size: 14px, @family: 'os-semibold');
        text-align: right;
        line-height: 40px;
        height: 40px;
        letter-spacing: 2px;
        padding-top: 10px;
        float: right;
      }

      .riga2 {
        width: 100%;
        .set-font(@color: #485eb5, @size: 10px, @family: 'os-semibold');
        text-align: center;
        line-height: 20px;
        height: 20px;
        float: right;
      }
    }
  }

  .el-carousel {
    height: 100%;

    .el-carousel__container {
      height: calc(100% - 32px);

      .el-carousel__item {
        .card-cm {
          //height: 48%;
          height: 70px; //110px;
          width: 50%;
          // display: inline-block;
          margin-bottom: 6px;
          float: left;

          .scheda {
            border: 1px solid #e7e7e7;
            border-radius: 4px;
            background: #fff;
            // -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
            // -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
            // box-shadow: 0px 0px 13px 1px #e7e7e7;
            width: 96%;
            margin: auto;
            height: 70px; //110px;
            text-align: center;

            &.image {
              background-image: url("../../../static/img/pdf-file.png");
              background-repeat: no-repeat;
              background-size: 20px;
              background-position: bottom right;
              background-position-x: 90%;
              background-position-y: 90%;
            }

            .scheda-cont {
              .set-font(@size: 14px; @color: #222D91);
              margin-top: 10px;
              height: 25px;
              line-height: 25px;
            }

            .scheda-data {
              // margin-top: 6px;
              .set-font(@size: 13px; @color: #B03488);
              font-weight: normal;
              line-height: 25px; //30px;
              height: 25px;
              text-transform: uppercase;
              letter-spacing: 1px;
            }

            .scheda-tipo {
              margin-top: 10px;
              text-transform: uppercase;
              .set-font(@size: 12px; @color: #3f2a6d);
            }

            &.important {
              border-left: 3px solid @rossoRiva;

              .scheda-cont {
                .set-font(@size: 14px; @color: #222D91; @family: 'os-semibold');
              }

              .scheda-data {
                // margin-top: 6px;
                .set-font(@size: 13px; @color: #B03488; @family: 'os-semibold');
              }
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/HomePage/ContentManager.vue